<template>
  <el-tabs tab-position="left">
    <el-tab-pane label="条件查询">
      <file-condition-finding></file-condition-finding>
    </el-tab-pane>
    <el-tab-pane label="日历图表">
      <calendar-table></calendar-table>
    </el-tab-pane>
    <el-tab-pane label="删除文件">
      <delete-logs></delete-logs>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import FileConditionFinding from './fileConditionFinding.vue';
import CalendarTable from './calendarTable.vue';
import DeleteLogs from './deleteFile.vue'
export default {
  components: {
    FileConditionFinding,
    CalendarTable,
    DeleteLogs
  }
}
</script>

